/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventAccess } from './EventAccess';
import {
    EventAccessFromJSON,
    EventAccessFromJSONTyped,
    EventAccessToJSON,
    EventAccessToJSONTyped,
} from './EventAccess';
import type { ScoringMode } from './ScoringMode';
import {
    ScoringModeFromJSON,
    ScoringModeFromJSONTyped,
    ScoringModeToJSON,
    ScoringModeToJSONTyped,
} from './ScoringMode';
import type { ClockState } from './ClockState';
import {
    ClockStateFromJSON,
    ClockStateFromJSONTyped,
    ClockStateToJSON,
    ClockStateToJSONTyped,
} from './ClockState';
import type { EventOrganizationStatus } from './EventOrganizationStatus';
import {
    EventOrganizationStatusFromJSON,
    EventOrganizationStatusFromJSONTyped,
    EventOrganizationStatusToJSON,
    EventOrganizationStatusToJSONTyped,
} from './EventOrganizationStatus';
import type { EventState } from './EventState';
import {
    EventStateFromJSON,
    EventStateFromJSONTyped,
    EventStateToJSON,
    EventStateToJSONTyped,
} from './EventState';
import type { JudgingMode } from './JudgingMode';
import {
    JudgingModeFromJSON,
    JudgingModeFromJSONTyped,
    JudgingModeToJSON,
    JudgingModeToJSONTyped,
} from './JudgingMode';
import type { EventParticipation } from './EventParticipation';
import {
    EventParticipationFromJSON,
    EventParticipationFromJSONTyped,
    EventParticipationToJSON,
    EventParticipationToJSONTyped,
} from './EventParticipation';
import type { FeedbackLevel } from './FeedbackLevel';
import {
    FeedbackLevelFromJSON,
    FeedbackLevelFromJSONTyped,
    FeedbackLevelToJSON,
    FeedbackLevelToJSONTyped,
} from './FeedbackLevel';

/**
 * An event the caller competes in, with the caller's competitor and clock.
 * 
 * For a user event the organization fields are null and the clock is the event window.
 * @export
 * @interface EventMineRead
 */
export interface EventMineRead {
    /**
     * 
     * @type {string}
     * @memberof EventMineRead
     */
    competition_id: string;
    /**
     * 
     * @type {string}
     * @memberof EventMineRead
     */
    name: string;
    /**
     * 
     * @type {EventParticipation}
     * @memberof EventMineRead
     */
    participation?: EventParticipation;
    /**
     * 
     * @type {EventAccess}
     * @memberof EventMineRead
     */
    access?: EventAccess;
    /**
     * 
     * @type {Date}
     * @memberof EventMineRead
     */
    available_start: Date;
    /**
     * 
     * @type {Date}
     * @memberof EventMineRead
     */
    available_end: Date;
    /**
     * 
     * @type {number}
     * @memberof EventMineRead
     */
    duration_minutes?: number | null;
    /**
     * 
     * @type {ScoringMode}
     * @memberof EventMineRead
     */
    scoring_mode?: ScoringMode;
    /**
     * 
     * @type {number}
     * @memberof EventMineRead
     */
    max_team_size?: number;
    /**
     * 
     * @type {FeedbackLevel}
     * @memberof EventMineRead
     */
    feedback?: FeedbackLevel;
    /**
     * 
     * @type {FeedbackLevel}
     * @memberof EventMineRead
     */
    feedback_after_close?: FeedbackLevel;
    /**
     * 
     * @type {JudgingMode}
     * @memberof EventMineRead
     */
    judging_mode?: JudgingMode;
    /**
     * 
     * @type {number}
     * @memberof EventMineRead
     */
    judging_radius?: number;
    /**
     * 
     * @type {number}
     * @memberof EventMineRead
     */
    judging_tolerance?: number;
    /**
     * 
     * @type {string}
     * @memberof EventMineRead
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventMineRead
     */
    created_by: string;
    /**
     * 
     * @type {Date}
     * @memberof EventMineRead
     */
    created_at: Date;
    /**
     * 
     * @type {EventState}
     * @memberof EventMineRead
     */
    state: EventState;
    /**
     * 
     * @type {number}
     * @memberof EventMineRead
     */
    organizations_count?: number;
    /**
     * 
     * @type {number}
     * @memberof EventMineRead
     */
    competitors_count?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EventMineRead
     */
    is_administrator: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventMineRead
     */
    competition_name: string;
    /**
     * 
     * @type {string}
     * @memberof EventMineRead
     */
    competitor_id: string;
    /**
     * 
     * @type {string}
     * @memberof EventMineRead
     */
    competitor_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventMineRead
     */
    organization_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventMineRead
     */
    organization_name?: string | null;
    /**
     * 
     * @type {EventOrganizationStatus}
     * @memberof EventMineRead
     */
    organization_status?: EventOrganizationStatus | null;
    /**
     * 
     * @type {Date}
     * @memberof EventMineRead
     */
    started_at?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EventMineRead
     */
    deadline?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof EventMineRead
     */
    seconds_remaining?: number | null;
    /**
     * 
     * @type {ClockState}
     * @memberof EventMineRead
     */
    clock_state: ClockState;
}



/**
 * Check if a given object implements the EventMineRead interface.
 */
export function instanceOfEventMineRead(value: object): value is EventMineRead {
    if (!('competition_id' in value) || value['competition_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('available_start' in value) || value['available_start'] === undefined) return false;
    if (!('available_end' in value) || value['available_end'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('created_by' in value) || value['created_by'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('is_administrator' in value) || value['is_administrator'] === undefined) return false;
    if (!('competition_name' in value) || value['competition_name'] === undefined) return false;
    if (!('competitor_id' in value) || value['competitor_id'] === undefined) return false;
    if (!('clock_state' in value) || value['clock_state'] === undefined) return false;
    return true;
}

export function EventMineReadFromJSON(json: any): EventMineRead {
    return EventMineReadFromJSONTyped(json, false);
}

export function EventMineReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventMineRead {
    if (json == null) {
        return json;
    }
    return {
        
        'competition_id': json['competition_id'],
        'name': json['name'],
        'participation': json['participation'] == null ? undefined : EventParticipationFromJSON(json['participation']),
        'access': json['access'] == null ? undefined : EventAccessFromJSON(json['access']),
        'available_start': (new Date(json['available_start'])),
        'available_end': (new Date(json['available_end'])),
        'duration_minutes': json['duration_minutes'] == null ? undefined : json['duration_minutes'],
        'scoring_mode': json['scoring_mode'] == null ? undefined : ScoringModeFromJSON(json['scoring_mode']),
        'max_team_size': json['max_team_size'] == null ? undefined : json['max_team_size'],
        'feedback': json['feedback'] == null ? undefined : FeedbackLevelFromJSON(json['feedback']),
        'feedback_after_close': json['feedback_after_close'] == null ? undefined : FeedbackLevelFromJSON(json['feedback_after_close']),
        'judging_mode': json['judging_mode'] == null ? undefined : JudgingModeFromJSON(json['judging_mode']),
        'judging_radius': json['judging_radius'] == null ? undefined : json['judging_radius'],
        'judging_tolerance': json['judging_tolerance'] == null ? undefined : json['judging_tolerance'],
        'id': json['id'],
        'created_by': json['created_by'],
        'created_at': (new Date(json['created_at'])),
        'state': EventStateFromJSON(json['state']),
        'organizations_count': json['organizations_count'] == null ? undefined : json['organizations_count'],
        'competitors_count': json['competitors_count'] == null ? undefined : json['competitors_count'],
        'is_administrator': json['is_administrator'],
        'competition_name': json['competition_name'],
        'competitor_id': json['competitor_id'],
        'competitor_name': json['competitor_name'] == null ? undefined : json['competitor_name'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'organization_status': json['organization_status'] == null ? undefined : EventOrganizationStatusFromJSON(json['organization_status']),
        'started_at': json['started_at'] == null ? undefined : (new Date(json['started_at'])),
        'deadline': json['deadline'] == null ? undefined : (new Date(json['deadline'])),
        'seconds_remaining': json['seconds_remaining'] == null ? undefined : json['seconds_remaining'],
        'clock_state': ClockStateFromJSON(json['clock_state']),
    };
}

export function EventMineReadToJSON(json: any): EventMineRead {
    return EventMineReadToJSONTyped(json, false);
}

export function EventMineReadToJSONTyped(value?: EventMineRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'competition_id': value['competition_id'],
        'name': value['name'],
        'participation': EventParticipationToJSON(value['participation']),
        'access': EventAccessToJSON(value['access']),
        'available_start': ((value['available_start']).toISOString()),
        'available_end': ((value['available_end']).toISOString()),
        'duration_minutes': value['duration_minutes'],
        'scoring_mode': ScoringModeToJSON(value['scoring_mode']),
        'max_team_size': value['max_team_size'],
        'feedback': FeedbackLevelToJSON(value['feedback']),
        'feedback_after_close': FeedbackLevelToJSON(value['feedback_after_close']),
        'judging_mode': JudgingModeToJSON(value['judging_mode']),
        'judging_radius': value['judging_radius'],
        'judging_tolerance': value['judging_tolerance'],
        'id': value['id'],
        'created_by': value['created_by'],
        'created_at': ((value['created_at']).toISOString()),
        'state': EventStateToJSON(value['state']),
        'organizations_count': value['organizations_count'],
        'competitors_count': value['competitors_count'],
        'is_administrator': value['is_administrator'],
        'competition_name': value['competition_name'],
        'competitor_id': value['competitor_id'],
        'competitor_name': value['competitor_name'],
        'organization_id': value['organization_id'],
        'organization_name': value['organization_name'],
        'organization_status': EventOrganizationStatusToJSON(value['organization_status']),
        'started_at': value['started_at'] == null ? undefined : ((value['started_at'] as any).toISOString()),
        'deadline': value['deadline'] == null ? undefined : ((value['deadline'] as any).toISOString()),
        'seconds_remaining': value['seconds_remaining'],
        'clock_state': ClockStateToJSON(value['clock_state']),
    };
}

